import mixitup from 'mixitup';

const mixitupContainer = document.querySelector('.seewirt-treatments');
const categoryElement = document.querySelector('.seewirt-treatments__category');

if (mixitupContainer) {
    const firstCategory = (categoryElement.getAttribute('data-category-first'))
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: ('.category-' + firstCategory)
        },
        selectors: {
            target: '.seewirt-treatments-accordion'
        },
        animation: {
            easing: 'ease-in-out'
        }
    });
}

const filterContainer = document.querySelector('.seewirt-treatments-filter');
const categoryElAll = document.querySelectorAll('.seewirt-treatments__category');

if (mixitupContainer) {
    
    filterContainer.addEventListener('click', () => {
        categoryElAll.forEach(function (el) {
        const activeClass = el.classList.contains('mixitup-control-active');
            if (activeClass) {
                filterContainer.classList.add('active');
            }
        });
    });
}